import React from "react";
import CartFailModal from "./CartBuyDisabledModal";
import CartLoadingSpinner from "./CartLoadingSpinner";
import CartSuccessModal from "./CartSuccessModal";

type Props = {
  isLoading: boolean;
  status: "success" | "disabled" | "loading" | "idle";
};

const ProductModalStatus = ({ isLoading, status }: Props) => {
  return (
    <>
      {(isLoading || status === "loading") && <CartLoadingSpinner />}
      {status === "success" && <CartSuccessModal isCloseable={true} />}
      {status === "disabled" && <CartFailModal />}
    </>
  );
};

export default ProductModalStatus;
